import { Component } from '@angular/core';

@Component({
  selector: 'i-stop',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144" fill="none">
      <path
        d="M22 30C22 25.5817 25.5817 22 30 22H114C118.418 22 122 25.5817 122 30V114C122 118.418 118.418 122 114 122H30C25.5817 122 22 118.418 22 114V30Z"
        fill="currentColor"
      />
    </svg>
  `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconStop {}
